// import time from "../../../src/IMAGES/time.png";
import error from "../IMAGES/error.jpg";

class blogView {
  _blogPost = document.querySelector(".blog_post");
  _sideBar = document.querySelector(".side_bar");
  _post = document.querySelector(".post");
  _blog = document.querySelector(".blog");
  _main = document.querySelector("main");
  _bar = document.querySelector(".latest_post");
  _error = document.querySelector(".error");

  constructor() {
    // this._addSpinner();
  }
  _blogDisplayData(upload) {
    let options = {
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    const date = new Intl.DateTimeFormat("en-US", options).format(upload.time);

    const markUp = `
  

  <div
  class="rounded-xl max-w-sm w-full text-lg h-full m-6 2sm:w-3/5 md:w-5/6 lg:w-2/6  post"
  data-tab="${upload.uid}"
>
  <div class="flex flex-col space-x-4">
    <div class="flex-1 space-y-6 py-1 w-full">
      <div class="h-fit bg-gray-200 rounded">
        <img
          class="h-full w-full rounded-xl"
          src="${upload.url}"
          alt=""
        />
      </div>
      <div class="space-y-4">
        <div class="h-fit rounded font-bold"><h1 class="text-base sm:text-sm ">${upload.title.toUpperCase()}</h1></div>
        <div class="h-fit rounded">
        <p class="text text-sm sm:text-xs">
        ${upload.text.slice(0, 80)}...
        </p>
        </div>
        <div class="h-fit rounded"> <span
        ><a href="" class="show_more text-sm sm:text-xs" 
          >Read More <i class="fa-solid fa-circle-arrow-right"></i
        ></a>
      </span></div>
        <div class="h-fit rounded">  <p class="date text-sm sm:text-xs">
        <i class="fa-regular fa-clock "></i> ${date}
        </p></div>
      </div>
    </div>
  </div>
</div>
    `;

    return markUp;
  }
  _clearPage() {
    this._blogPost.innerHTML = "";
    this._sideBar.innerHTML = "";
  }
  _errorMessage() {
    const markUp = `
    
          <section class="error flex items-center flex-col mb-6">
          <section class="img_err">
            <img src="${error}" alt="" />
          </section>
          <section class="text_err">
            <h3>No Blogs Yet... Check back later</h3>
          </section>
        </section>

      
    
    `;
    this._clearPage();
    this._blog.insertAdjacentHTML("afterbegin", markUp);
  }

  _sideBlog(latest) {
    let options = {
      year: "numeric",
      month: "long",
      day: "numeric",
    };

    const date = new Intl.DateTimeFormat("en-US", options).format(latest.time);

    const markUp = `
      <section class="post flex  justify-around mb-4 items-start" data-tab="${
        latest.uid
      }">
      <section class="w-6/12 h-fit  img">
      <img class="rounded-xl" src="${latest.url}" alt="">
      </section>
      <section class="w-full text ml-2 ">
        <h1 class="font-bold text-sm 2sm:text-xs md:text-xs">${latest.title.toUpperCase()}</h1>
        <h1 class=" mt-1 text-xs">${date}</h1>
      </section>
      </section>
      `;
    return markUp;
  }

  _addHandlerMore(handler) {
    this._main.addEventListener("click", function (e) {
      const target = e.target.closest(".post");
      if (!target) return;
      if (target) {
        e.preventDefault();
        const id = target.dataset.tab;
        console.log(id);
        handler(id);
      }

      // setTimeout(() => (location.href = html), 1000);
    });
  }

  _renderUpload(upload) {
    const markUp = this._blogDisplayData(upload);
    this._blogPost
      ? this._blogPost.insertAdjacentHTML("afterbegin", markUp)
      : "";
  }
  _renderSideBlog(latest) {
    const markUp = this._sideBlog(latest);
    this._bar?.insertAdjacentHTML("afterbegin", markUp);
  }
  _clear() {
    this._blogPost.textContent = "";
  }
}

export default new blogView();
